import { FeatureFlag } from '../FeatureFlag';

export const enableInstrumentManagement = new FeatureFlag({
    key: 'enable-instrument-management',
    defaultValue: false,
});
